import { useContext, Dispatch } from 'react'
import { useParams } from 'react-router'
import { IPublishScheduleActionType, IPublishScheduleFormState } from '../../types/publishSchedule'
import {
  getSchedules as getSchedulesAction,
  getSchedulesSuccess,
  getSchedulesFailure
} from '../../actions/publishSchedule'
import { trace } from '../../services/common'
import { getSchedules } from '../../services/publishSchedule'
import { useCustomSnackbar } from '../CustomSnackbar/hook'
import { PublishScheduleStateContext, PublishScheduleDispatchContext } from './context'

export const usePublishScheduleState = (): IPublishScheduleFormState => {
  const context = useContext(PublishScheduleStateContext)
  if (context === undefined) {
    throw new Error('usePublishScheduleState must be used within a PublishScheduleProvider')
  }
  return context
}

export const usePublishScheduleDispatch = (): Dispatch<IPublishScheduleActionType> => {
  const context = useContext(PublishScheduleDispatchContext)
  if (context === undefined) {
    throw new Error('usePublishScheduleDispatch must be used within a PublishScheduleProvider')
  }
  return context
}

export const usePublishSchedule = (): [IPublishScheduleFormState, Dispatch<IPublishScheduleActionType>] => {
  return [usePublishScheduleState(), usePublishScheduleDispatch()]
}

export const useFetchSchedules = () => {
  const { packId } = useParams() as { packId: string }
  const [, setSnackbarMessage] = useCustomSnackbar()
  const dispatch = usePublishScheduleDispatch()
  return async () => {
    try {
      dispatch(getSchedulesAction())
      const items = await getSchedules(packId)
      dispatch(getSchedulesSuccess(items))
    } catch (err) {
      trace(err)
      setSnackbarMessage(err)
      dispatch(getSchedulesFailure())
    }
  }
}
